import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Send, Sparkles, Plus } from "lucide-react";
import { toast } from "sonner";

const ESEMPI = [
  "Voglio un sistema integrato officina: scansione QR per aprire interventi, dashboard, magazzino ricambi",
  "Mi serve un portale fornitori dove caricano bolle, vediamo lo stato ordini e comunichiamo",
  "Voglio integrare ticketing IT con knowledge base aziendale e chat interna",
  "Mi serve un sistema completo per monitorare consumi energetici con dashboard e ticketing per interventi",
];

export default function Componi() {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [apps, setApps] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/composable-apps").then((r) => setApps(r.data.items || []));
  }, []);

  const submit = async (msg) => {
    if (msg.trim().length < 20) {
      toast.error("Descrivi meglio (almeno 20 caratteri)");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/composable-apps", { initial_prompt: msg });
      nav(`/componi/${data.id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div>
      <div className="adr-overline mb-3 text-[#C8102E]">Composable Builder · Modulo 4</div>
      <h1 className="serif text-3xl sm:text-4xl font-semibold tracking-tight text-[#1A1A1A] mb-3">
        Costruisci un'app combinando software open source maturi
      </h1>
      <p className="text-[#555555] mb-8 max-w-2xl">
        Il Composable Builder analizza la tua richiesta, sceglie i progetti giusti dal catalogo OSS e li compone in un'unica applicazione con SSO e dati condivisi. Risk-friendly per la PMI: massima maturità, minimo codice custom.
      </p>

      <form onSubmit={(e) => { e.preventDefault(); submit(text); }} className="relative max-w-3xl" data-testid="componi-form">
        <textarea value={text} onChange={(e) => setText(e.target.value)} placeholder="Es. Voglio un sistema integrato per la mia officina meccanica: scansione QR per aprire interventi, dashboard del responsabile, alert al direttore se intervento dura più di 48 ore..." className="adr-input min-h-[140px] resize-none pr-14" data-testid="componi-input" />
        <button type="submit" disabled={loading || text.length < 20} className="absolute right-3 bottom-3 w-11 h-11 rounded-md text-white flex items-center justify-center disabled:opacity-40" style={{ background: "#C8102E" }} data-testid="componi-send">
          <Send className="w-4 h-4" />
        </button>
      </form>

      <div className="mt-8 max-w-3xl">
        <div className="adr-overline mb-3">Esempi pre-pronti</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {ESEMPI.map((e, i) => (
            <button key={i} onClick={() => submit(e)} className="adr-card text-left p-4" data-testid={`componi-esempio-${i}`}>
              <div className="flex items-start gap-3">
                <Sparkles className="w-4 h-4 text-[#0F3D6B] flex-shrink-0 mt-0.5" />
                <span className="text-sm">{e}</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <div className="mt-12 max-w-4xl">
        <div className="flex items-center justify-between mb-3">
          <h2 className="serif text-xl font-semibold">Le mie app composable</h2>
          <Link to="/componi" className="adr-btn-outline text-xs"><Plus className="w-3 h-3 inline mr-1" /> Nuova</Link>
        </div>
        {apps.length === 0 ? (
          <p className="text-sm text-[#555555] italic">Nessuna ancora. Inizia con un esempio o descrivi il tuo caso.</p>
        ) : (
          <div className="space-y-2">
            {apps.map((a) => (
              <Link key={a.id} to={`/componi/${a.id}`} className="adr-card p-4 block" data-testid={`comp-app-${a.id}`}>
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0 flex-1">
                    <div className="serif font-semibold text-[#1A1A1A] truncate">{a.title}</div>
                    <div className="text-xs text-[#555555]">{new Date(a.created_at).toLocaleString("it-IT")} · v{a.current_version}</div>
                  </div>
                  <span className="text-xs text-[#0F3D6B] capitalize">{a.status.replace("_", " ")}</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>

      <div className="text-xs text-[#555555] mt-10 max-w-3xl">
        Quota: 3 app composable per organizzazione al mese. Stack: docker-compose + Traefik + Keycloak + componenti del catalogo OSS + glue FastAPI + UI shell Next.js. Disclaimer: revisione tecnica obbligatoria prima del go-live in produzione.
      </div>
    </div>
  );
}
